import { render, staticRenderFns } from "./double-opt-in-explanation.vue?vue&type=template&id=4084a518&scoped=true&"
import script from "./double-opt-in-explanation.vue?vue&type=script&lang=js&"
export * from "./double-opt-in-explanation.vue?vue&type=script&lang=js&"
import style0 from "./double-opt-in-explanation.vue?vue&type=style&index=0&id=4084a518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084a518",
  null
  
)

export default component.exports